import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Header from "./components/common/Header";
import Private from "components/common/Private";
import { AuthProvider, useAuth } from "hooks/useAuth";

import Main from "./pages/Main";
import Settings from "./pages/Settings";
import Upload from "./pages/Upload";
import Status from "./pages/Status";
import Info from "./pages/Info";
import Notfound from "./pages/Notfound";
import Login from "pages/Login";
import Users from "pages/Users";

import { Center, Heading, Spinner, Alert, AlertIcon, VStack } from "@chakra-ui/react";
import { useGroup } from "hooks/useGroup";

function AppContent() {
  const { selected: group } = useGroup();
  const { loading, isAuthenticated, user } = useAuth();

  // beforeunload 이벤트 완전 제거
  useEffect(() => {
    const removeBeforeUnload = () => {
      window.onbeforeunload = null;
      window.removeEventListener('beforeunload', () => {});
    };
    
    removeBeforeUnload();
    
    // 컴포넌트 언마운트 시에도 제거
    return removeBeforeUnload;
  }, []);

  if (loading) {
    return (
      <Center height="100vh">
        <VStack spacing={4}>
          <Spinner size="xl" />
          <Heading size="md">로딩 중...</Heading>
        </VStack>
      </Center>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        {!isAuthenticated ? (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        ) : group === "WaitGroup" ? (
          <Center position={"fixed"} width={"100vw"} top={"50%"}>
            <VStack spacing={4}>
              <Alert status="warning" borderRadius="md" maxWidth="600px">
                <AlertIcon />
                <VStack align="start" spacing={2}>
                  <Heading size="md">계정 승인 대기 중</Heading>
                  <div>관리자가 적절한 그룹을 할당할 때까지 기다려주세요.</div>
                  <div>이메일: {user?.email}</div>
                </VStack>
              </Alert>
            </VStack>
          </Center>
        ) : (
          <Routes>
            <Route path="/" element={<Private><Main /></Private>} />
            <Route path="/settings" element={<Private><Settings /></Private>} />
            <Route path="/upload" element={<Private><Upload /></Private>} />
            <Route path="/status" element={<Private><Status /></Private>} />
            <Route path="/info/:id" element={<Private><Info /></Private>} />
            <Route path="/users" element={<Private><Users /></Private>} />
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Notfound />} />
          </Routes>
        )}
      </BrowserRouter>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
